import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Table, Input, Button} from 'reactstrap';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import './AccreditationRequestsByGroupList.css';
import RejectAccreditationRequestsByGroupModal from "../accreditationModal/rejectAccreditationRequestsByGroupModal/RejectAccreditationRequestsByGroupModal.container";
import SetAccreditationGroupForRequestsModal from "../accreditationModal/setAccreditationGroupForRequestsModal/SetAccreditationGroupForRequestsModal.container";
import PaginationUnreferencedAccreditationRequestsByAGs from "../../commonComponents/paginationComponent/PaginationUnreferencedAccreditationRequestsByAGs.container";
import { Utils } from '../../../utils/utils';

const SUCCESS_MESSAGE_PATH_BY_ACTION = {
    REMOVE: 'accreditation_requests.remove_accreditation_requests_success_message',
    EDIT: 'accreditation_requests.set_accreditation_group_for_selected_requests_success_message'
};

class AccreditationRequestsByGroupList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedRowData: null,
            filterValue: '',
            successMessage: '',
            selected: [],
            filtering: false,
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    render() {
        return (
            <div className='accreditation-requests-by-group-list-container'>
                <FormWrapper successMessage={_.get(this.props.translation, this.state.successMessage)}>
                    <h4 className='page-label'>{_.get(this.props.translation, 'accreditation_requests.accreditation_requests_by_group_label')}</h4>
                    <div className="accreditation-requests-by-group-hint-container">
                        <div>
                            {Utils.getTagsFromStringWithStyles(
                                _.get(this.props.translation, 'accreditation_requests.accreditation_requests_by_group_hint_part_1')
                            )}
                        </div>
                        <div>
                            {Utils.getTagsFromStringWithStyles(
                                _.get(this.props.translation, 'accreditation_requests.accreditation_requests_by_group_hint_part_2')
                            )}
                        </div>
                        <div>
                            {Utils.getTagsFromStringWithStyles(
                                _.get(this.props.translation, 'accreditation_requests.accreditation_requests_by_group_hint_part_3')
                            )}
                        </div>
                    </div>
                    <PaginationUnreferencedAccreditationRequestsByAGs/>
                    {this.renderTable()}
                    <RejectAccreditationRequestsByGroupModal onReject={this.handleReject}/>
                    <SetAccreditationGroupForRequestsModal onSetAccreditationGroup={this.handleSetAccreditationGroup}/>
                </FormWrapper>
            </div>
        );
    }

    renderTable = () => {
        if (this.props.loading && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="accreditation-requests-by-group-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (!this.state.filtering && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="accreditation-requests-by-group-list-status-message-container">
                    <h6>{_.get(this.props.translation, 'accreditation_requests.accreditation_requests_list_no_data_label')}</h6>
                </div>
            );
        }

        return [
            <div className='buttons-group' key='buttons-group'>
                <Button className='carrot-red-btn' disabled={_.isEmpty(this.state.selected)} onClick={this.handleRejectButtonClick}>
                    {_.get(this.props.translation, 'accreditation_requests.reject_selected_button')}
                </Button>
                <Button className='olive-green-btn' disabled={_.isEmpty(this.state.selected)} onClick={this.handleSetAGButtonClick}>
                    {_.get(this.props.translation, 'accreditation_requests.set_accreditation_group_for_selected_button')}
                </Button>
            </div>,
            <Table className='accreditation-requests-by-group-list-table'
                   key='accreditation-requests-by-group-list-table'>
                <thead>
                <tr>
                    <th>
                        {this.renderSelectAllCheckbox()}
                    </th>
                    <th className='group-th'>
                        {_.get(this.props.translation, sharedLabelsPath.accreditation_group_label)}
                        <Input id='input'
                               value={this.state.filterValue}
                               onChange={this.handleChangeFilterValue}
                               onKeyDown={this.handleKeyDown}
                               onBlur={this.handleFilter}
                               className='group-filter-input'
                               bsSize="sm"
                               placeholder={_.get(this.props.translation, sharedLabelsPath.accreditation_group_label)}/>
                    </th>
                    <th className='number-th'>
                        {_.get(this.props.translation, 'accreditation_requests.accreditation_requests_number_label')}
                    </th>
                </tr>
                </thead>
                <tbody>
                {this.renderAccreditationRequestsByDomainsData()}
                </tbody>
            </Table>
        ]
    };

    renderSelectAllCheckbox = () => {
        let allSelected = !_.isNil(this.props.data) && !_.isEmpty(this.props.data) && _.chain(this.props.data)
            .map(data => data.value)
            .xor(this.state.selected)
            .value()
            .length === 0;

        if (allSelected) {
            return (
                <IconContainer className='accreditation-request-checkbox' icon='check_box'
                           onClick={this.onToggleSelectAllCheckBox}/>
            )
        } else {
            return (
                <IconContainer className='accreditation-request-checkbox' icon='check_box_outline_blank'
                               onClick={this.onToggleSelectAllCheckBox}/>
            )
        }
    };

    renderAccreditationRequestsByDomainsData = () => {
        return _.map(this.props.data, (data) => (
            <tr className="accreditation-requests-list-row" key={data.value} onClick={this.onToggleSelectCheckbox(data.value)}>
                <td className='selected-check-box'>
                    {
                        _.includes(this.state.selected, data.value) ?
                            <IconContainer className='accreditation-request-checkbox' icon='check_box' key={data.value + '_checkbox'}/> :
                            <IconContainer className='accreditation-request-checkbox' icon='check_box_outline_blank' key={data.value + '_checkbox'}/>
                    }
                </td>
                <td className='group-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.accreditation_group_label) + ':'}>
                    {data.value}
                </td>
                <td className='relative-edit-icon'>
                    <IconContainer icon='create'
                                   key={data.id + '-create'}
                                   className="relative-create-accreditation-request-icon"
                                   title={_.get(this.props.translation, 'accreditation_requests.edit_accreditation_request_label')}/>
                </td>
                <td className='number-td'
                    data-th={_.get(this.props.translation, 'accreditation_requests.accreditation_requests_number_label') + ':'}>
                    {data.amount}
                </td>
            </tr>
        ))
    };

    onToggleSelectAllCheckBox = () => {
        if (this.state.selected.length !== this.props.data.length) {
            this.setState({selected: _.map(this.props.data, data => data.value)});
        } else {
            this.setState({selected: []});
        }
    };

    onToggleSelectCheckbox = (value) => (e) => {
        e.stopPropagation();
        if (_.includes(this.state.selected, value)) {
            this.setState({selected: _.pull([...this.state.selected], value)});
        } else {
            this.setState({selected: [...this.state.selected, value]});
        }
    };

    handleChangeFilterValue = (e) => {
        this.setState({filterValue: e.target.value, filtering: true});
    };

    handleSetAGButtonClick  = () => {
        this.setState({successMessage: SUCCESS_MESSAGE_PATH_BY_ACTION.EDIT});
        this.props.onAccreditationRequestsSetAG();
    };

    handleRejectButtonClick = () => {
        this.setState({successMessage: SUCCESS_MESSAGE_PATH_BY_ACTION.REMOVE});
        this.props.onAccreditationRequestsReject();
    };

    handleKeyDown = (e) => {
        if (e.keyCode === 13) {
            this.handleFilter();
        }
    };

    handleFilter = () => {
        if (!this.state.filterValue || this.state.filterValue === '') {
            this.setState({ filtering: false });
        }
        this.props.onFilterByGroup(this.state.filterValue);
    };

    handleReject = () => {
        this.props.onReject(this.state.selected);
        this.setState({selected: []});
    };

    handleSetAccreditationGroup = (group) => {
        this.props.onSetAccreditationGroup(group, this.state.selected);
        this.setState({selected: []});
    }
}

AccreditationRequestsByGroupList.propTypes = {
    translation: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.array,
    onMount: PropTypes.func.isRequired,
    onAccreditationRequestsReject: PropTypes.func.isRequired,
    onAccreditationRequestsSetAG: PropTypes.func.isRequired,
    onFilterByGroup: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
    onSetAccreditationGroup: PropTypes.func.isRequired
};

export default AccreditationRequestsByGroupList;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationRequestsByGroupList/AccreditationRequestsByGroupList.js